import type { CapitalGlobalProposalStepProps } from '@/features/proposals/components/capital-global/capital-global-proposal-step.types';
import { Button } from '@noorden-insurtech/alba-design-system';
import { ArrowLeft } from 'lucide-react';

type Props = Pick<
  CapitalGlobalProposalStepProps,
  'isViewMode' | 'canGoBack' | 'onBack'
> & {
  onExit: () => void;
};

export function CapitalGlobalProposalAssinaturaFooter({
  isViewMode,
  canGoBack,
  onBack,
  onExit,
}: Props) {
  return (
    <div className='flex flex-row items-center justify-between gap-6 px-6'>
      <Button
        type='button'
        variant='ghost'
        size='lg'
        className='flex items-center gap-2'
        onClick={onBack}
        disabled={isViewMode || !canGoBack}
      >
        <ArrowLeft className='h-5 w-5' strokeWidth={1.6} />
        Voltar
      </Button>
      <Button
        type='button'
        variant='primary'
        size='md'
        className='rounded-xl px-8 py-2'
        onClick={onExit}
      >
        Sair
      </Button>
    </div>
  );
}
